var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9477 20.64C38.2938 12.3492 31.6508 5.70616 23.36 5.05231C22.9154 5.02616 22.4446 5 22 5C12.6108 5 5 12.6108 5 22C5 31.3892 12.6108 39 22 39C31.3892 39 39 31.3892 39 22C39 21.5554 38.9738 21.0846 38.9477 20.64ZM24.3015 24.3015L22 28.5385L19.6985 24.3015L15.4615 22L19.6985 19.6985L22 15.4615L24.3015 19.6985L28.5385 22L24.3015 24.3015Z",
    fill: "#FFDEC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.3602d5f703b6c4a4ed31d235e58c4fad.svg";
export { ForwardRef as ReactComponent };